
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/react-card",
      function () {
        return require("private-next-pages/material-ui/react-card.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/react-card"])
      });
    }
  